import React from 'react';
import {string} from 'prop-types';
import classnames from 'classnames';
import {Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

const SecretSonicSpinner = props => (
  <div className={classnames('loading-spinner fadeInDown animResponse', props.className)}>
    {(Math.random() > 0.98) ? (
      <React.Fragment>
        <img src='http://rsmg.pbsrc.com/albums/v642/exactoman/Animated%20GIFs/Video%20Game%20GIFs/Sonic/thsonicrunning.gif~c200' />
        <p><FormattedMessage id='loading.sonic' /></p>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <Icon loading name='spinner' size='huge' />
        <p>{props.messageKey ? <FormattedMessage id={props.messageKey} /> : props.message}</p>
      </React.Fragment>
    )}
  </div>
);

SecretSonicSpinner.propTypes = {
  className: string,
  message: string,
  messageKey: string
};

SecretSonicSpinner.defaultProps = {
  className: '',
  message: ''
};

export default SecretSonicSpinner;



// WEBPACK FOOTER //
// ./public/components/common/SecretSonicSpinner.jsx